import React from "react";
import { Skeleton } from "./ui/skeleton";

const AccordionSkeleton = ({
  count = 3,
  showImages = false,
  gridColumns = 3,
  className = ""
}) => {
  return (
    <div className={`space-y-2 ${className}`}>
      {Array.from({ length: count }).map((_, index) => (
        <div
          key={index}
          className="rounded-lg border bg-card text-card-foreground shadow-sm p-0 mb-2"
          style={{
            backgroundColor: "#2a2a2a",
            border: "1px solid rgba(255,255,255,0.1)"
          }}
        >
          {/* Accordion Header */}
          <div className="flex items-center justify-between p-4">
            <div className="flex items-center space-x-3">
              {/* Folder title */}
              <Skeleton className="h-6 w-48" />
            </div>
            <div className="flex items-center space-x-3">
              {/* Selection count */}
              <Skeleton className="h-5 w-20" />
              {/* Expand icon */}
              <Skeleton className="h-6 w-6 rounded" />
            </div>
          </div>

          {/* Optional Image Grid Preview */}
          {showImages && (
            <div className="px-4 pb-4">
              <div
                className="grid gap-2"
                style={{
                  gridTemplateColumns: `repeat(${Math.min(gridColumns, 4)}, minmax(0, 1fr))`
                }}
              >
                {Array.from({ length: Math.min(gridColumns * 2, 8) }).map((_, imgIndex) => (
                  <div key={imgIndex} className="aspect-[3/2] relative">
                    <Skeleton className="w-full h-full rounded-md" />
                    {/* Shimmer effect */}
                    <div
                      className="absolute inset-0 animate-shimmer bg-gradient-to-r from-transparent via-white/10 to-transparent rounded-md"
                      style={{
                        animationDelay: `${imgIndex * 0.1}s`
                      }}
                    />
                  </div>
                ))}
              </div>
            </div>
          )}
        </div>
      ))}

    </div>
  );
};

export default AccordionSkeleton;